export const getMapOverviewData = (data) =>
{
    const bbox = { ltLat: 0, ltLon: 0, rbLat: 0, rbLon: 0 };
    const mapPlots = [];
    const mapPolygons = [];

    // get plan polys
    for (let i = 0; i < data?.length; i++) {
        const k = {};
        const coordinantes = data?.[i].polygon;
        let coordinatesConverted = [];

        if (coordinantes?.['type'] === 'Polygon') {
            coordinatesConverted = coordinantes?.['coordinates']?.[0]?.[0];
        } else if (coordinantes?.['type'] === 'MultiPolygon') {
            coordinatesConverted =
                coordinantes?.['coordinates']?.[0]?.[0]?.[0];
        }

        k['name'] = data[i].name;
        k['type'] = 'Feature';
        k['properties'] = {};
        k['id'] = data[i].id;
        k['geometry'] = {
            type: 'Point',
            coordinates: coordinatesConverted,
        };

        if (bbox.ltLat < coordinatesConverted?.[0] || bbox.ltLat === 0) {
            bbox.ltLat = coordinatesConverted?.[0];
        }

        if (bbox.rbLat > coordinatesConverted?.[0] || bbox.rbLat === 0) {
            bbox.rbLat = coordinatesConverted?.[0];
        }

        if (bbox.ltLon > coordinatesConverted?.[1] || bbox.ltLon === 0) {
            bbox.ltLon = coordinatesConverted?.[1];
        }

        if (bbox.rbLon < coordinatesConverted?.[1] || bbox.rbLon === 0) {
            bbox.rbLon = coordinatesConverted?.[1];
        }

        mapPlots.push(k);
    }

    // get plan polys
    for (let i = 0; i < data?.length; i++) {
        const k = {};
        const coordinantes = data?.[i].polygon;

        if (typeof coordinantes?.coordinates !== 'undefined') {
            k['name'] = data[i].name;
            k['type'] = 'Feature';
            k['properties'] = data?.[i];
            k['id'] = data[i].id;
            k['geometry'] = coordinantes;

            mapPolygons.push(k);
        } else {
            //console.log('-- Fehler --');
        }
    }

    return {
        bbox: bbox,
        mapPlots: mapPlots,
        mapPolygons: mapPolygons,
    };

}